import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ImmunizationIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M16.9965 0.789001C13.6175 3.771 9.18146 5.58 4.32046 5.58V18.86C4.32046 25.683 16.9965 31.212 16.9965 31.212C16.9965 31.212 29.6715 25.683 29.6715 18.86V5.58C24.8125 5.58 20.3735 3.771 16.9965 0.789001Z"
        fill="#00BFEA"
      />
      <path
        d="M16.9965 25.127C22.0372 25.127 26.1235 21.0407 26.1235 16C26.1235 10.9593 22.0372 6.87299 16.9965 6.87299C11.9558 6.87299 7.86946 10.9593 7.86946 16C7.86946 21.0407 11.9558 25.127 16.9965 25.127Z"
        fill="white"
      />
      <path
        d="M18.6855 14.311V10.93H15.3065V14.311H11.9265V17.69H15.3065V21.07H18.6855V17.69H22.0665V14.311H18.6855Z"
        fill="#D9002C"
      />
      <path
        d="M29.6725 4.791C25.1905 4.791 20.8735 3.16 17.5185 0.198C17.2865 -0.00799957 16.9545 -0.0579996 16.6735 0.0700004C16.5955 0.104 16.5275 0.151 16.4665 0.206C13.1105 3.163 8.79846 4.791 4.32046 4.791C3.88446 4.791 3.53146 5.145 3.53146 5.58V18.86C3.53146 26.116 16.1445 31.7 16.6825 31.934C16.7825 31.979 16.8895 32 16.9965 32C17.1035 32 17.2115 31.979 17.3125 31.935C17.8475 31.701 30.4605 26.117 30.4605 18.861V5.58C30.4615 5.145 30.1075 4.791 29.6725 4.791ZM28.8835 18.86C28.8835 22.041 25.6295 25.006 22.8995 26.935C20.4015 28.701 17.8665 29.939 16.9975 30.344C16.1305 29.941 13.6115 28.71 11.1145 26.948C8.37546 25.016 5.11046 22.046 5.11046 18.859V6.354C9.46346 6.182 13.6345 4.594 16.9965 1.826C20.3575 4.594 24.5295 6.181 28.8825 6.353V18.86H28.8835Z"
        fill="black"
      />
      <path
        d="M7.08046 16C7.08046 21.468 11.5285 25.916 16.9975 25.916C22.4635 25.916 26.9135 21.468 26.9135 16C26.9135 10.533 22.4645 6.08499 16.9975 6.08499C11.5285 6.08499 7.08046 10.533 7.08046 16ZM25.3345 16C25.3345 20.598 21.5945 24.338 16.9975 24.338C12.3995 24.338 8.65946 20.598 8.65946 16C8.65946 11.403 12.3995 7.66299 16.9975 7.66299C21.5945 7.66299 25.3345 11.403 25.3345 16Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.99646)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default ImmunizationIcon;
